<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Manage Audit Drafts">
      <v-card-actions>
        <!-- <v-btn class="add-audit-offline"
          v-on:click="()=>{$router.push({ name: 'addAudit', params: {type: 'online'} })}"
          v-if="isWrite" elevation="1" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
          <v-icon left>mdi-plus</v-icon>
          Add Audit
        </v-btn> -->
        <a @click="$router.back()">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1"
            class="mr-n2 mt-10" style="opacity:.6;">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <!-- <v-btn class="add-audit-offline"
        v-on:click="()=>{$router.push({ name: 'addAudit', params: {type: 'online'} })}"
        v-if="isWrite" elevation="1" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
        <v-icon left>mdi-plus</v-icon>
        Start New Audit
      </v-btn> -->
      <!-- <v-btn class="add-audit-online"
        v-on:click="()=>{$router.push({ name: 'addAudit', params: {type: 'online'}})}"
        v-if="isWrite" elevation="1" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
        <v-icon left>mdi-plus</v-icon>
        Online Audit
      </v-btn> -->
      <v-card-component>

        <!--Data table start -->
        <v-data-table :headers="headers" :items="auditData" :search="search" disable-pagination
          hide-default-footer>

          <template v-slot:item.actions="{ item }">
            <v-btn v-if="!item.isPublish" color="success" class="px-2 ml-1 ma-1" min-width="0" small
              v-on:click="()=>{$router.push({ name: 'editAudit', params: {id: item.id} })}">
              <v-icon small> mdi-pencil </v-icon>
            </v-btn>

            <!-- <v-btn color="error" v-if="item.isActive" class="px-2 ml-1 ma-1" min-width="0" small>
              <v-icon small> mdi-trash-can-outline </v-icon>
            </v-btn>
            <v-btn color="success" v-else class="px-2 ml-1 ma-1" min-width="0" small>
              <v-icon small> mdi-reload </v-icon>
            </v-btn> -->
          </template>

          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
        <!--Data table end -->
        <!--Pagination start-->
        <v-row>
          <v-col cols="4" sm="3">
            <v-select v-model="pageSize" :items="pageSizes" label="Items per Page"
              @change="handlePageSizeChange"></v-select>
          </v-col>
          <v-col cols="12" sm="9">
            <v-pagination v-model="page" :length="totalPages" :total-visible="totalPages"
              @input="handlePageChange">
            </v-pagination>
          </v-col>
        </v-row>
        <!--Pagination end-->
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  components: { VCardComponent, MaterialCard },
  async created () {
    this.franchiseeID = this.franchisee.id
    this.academicYearID = this.academicYear.id
    await this.getClassList()
    await this.getAcadAudits()
    await this.getTeacherList()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      console.log(val)
      this.franchiseeID = val.id
      this.getClassList()
      this.getAcadAudits()
      this.getTeacherList()
    },
    academicYear: async function (val) {
      console.log(val)
      this.academicYearID = val.id
      this.getClassList()
      this.getAcadAudits()
    }
  },
  data () {
    return {
      page: 1,
      pageSize: 10,
      pageSizes: [5, 10, 20],
      totalPages: 0,
      isWrite: true,
      search: '',
      franchiseeID: '',
      academicYearID: '',
      selectedClassId: '',
      classList: [],
      auditData: [],
      headers: [
        { text: 'Staff Name', value: 'auditeeDetails', sortable: true },
        { text: 'Date', value: 'auditDate', sortable: true },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false }
      ],
      date: new Date().toISOString().substr(0, 7),
      menu: false,
      modal: false,
      scoreOptions: [],
      score: '',
      staffOptions: [],
      staff: ''
    }
  },
  methods: {
    getTeacherList: async function () {
      if (this.franchiseeID) {
        // staff/teacher-class-map
        let rows = await http.get(`${constants.API_URL}/api/staff/approved`, {
          params: {
            franchiseeID: this.franchiseeID,
            isTeachingStaff: true
          }
        })
        console.log('____Teacher list___', rows.data)
        this.staffOptions = rows.data
      }
    },
    getAcadAudits: async function () {
      try {
        if (this.franchisee && this.academicYear) {
          let rows = await http.get(`${constants.API_URL}/api/center-audit/audit`, {
            params: {
              franchiseeID: this.franchiseeID,
              academicYearID: this.academicYear.id,
              // classID: this.selectedClassId,
              page: this.page - 1,
              size: this.pageSize,
              isPublish: false
            }
          })
          this.totalPages = rows.data.totalPages
          this.auditData = rows.data.rows.map((item) => {
            item.auditeeDetails = `${item.auditeeName[0].firstName} ${item.auditeeName[0].lastName}`
            item.classDetails = item.className[0].name
            item.auditDate = moment(item.auditDate).format('LL')
            return item
          })
          console.log('__Audit Data__', this.auditData)
        } else {
          console.log(`${this.franchisee}||${this.academicYear} ||${this.selectedClassId}`)
        }
      } catch (e) {
        console.log(e)
      }
    },
    getClassList: async function () {
      if (this.franchisee && this.academicYear) {
        let rows = await http.get(`${constants.API_URL}/api/student/get-all-classby-franchisee`, {
          params: {
            franchiseeID: this.franchisee.id,
            academicYearID: this.academicYear.id
          }
        })
        this.classList = rows.data
        this.selectedClassId = this.classList[0] ? this.classList[0].id : ''
        this.getAcadAudits()
      } else {
        console.log('Class list fetch failed')
      }
    },
    handlePageChange: function () {
      console.log(`Page: ${this.page}`)
      this.getAcadAudits()
    },
    handlePageSizeChange: function () {
      console.log(`Page Size: ${this.pageSize}`)
      this.getAcadAudits()
    }
  }
}
</script>

<style scoped>
.add-audit-offline {
  position: absolute;
  right: 150px;
  top: 18px;
}
.add-audit-online {
  position: absolute;
  right: 180px;
  top: 0;
}
</style>
